goog.require('el8.app.setup');
goog.require('el8.appanalytics.dialog.scheduleReportCSV');
goog.require('el8.data.practiceUsers');
goog.require('el8.service.infoField');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.uiwidget.addDatepicker');
goog.require('el8.uiwidget.nonAlarmingAlert');
goog.require('el8.util.datecompare');

var el8 = el8 || {};
if(!el8.main) { el8.main = {}; }

el8.main.appScheduleReport = {
    fromDateInfoField: null,
    toDateInfoField: null
};

el8.main.appScheduleReport._getParams = function() {
    var from_str = this.fromDateInfoField.getVal() || null;
    var to_str = this.toDateInfoField.getVal() || null;

    if (!from_str || !to_str) {
        el8.uiwidget.nonAlarmingAlert('Both start date and end date are requred');
        return;
    }

    var f = el8.util.datecompare.dateFromStr(from_str);
    var t = el8.util.datecompare.dateFromStr(to_str);

    if (el8.util.datecompare.daysBetween(f, t) > 180) {
        el8.uiwidget.nonAlarmingAlert('Please select a range of 6 months or less');
        return;
    }

    if (f > t) {
        el8.uiwidget.nonAlarmingAlert('Please select a start date less than or equal to the end date');
        return;
    }

    var physicianIdorKey = $('#schedule-report-physician-select').val() || null;
    var key = null;
    var physicianId = null;

    if (physicianIdorKey === 'all') {
        key = 'all';
    } 
    else if (physicianIdorKey === 'select') {
        key = 'select';
    } 
    else {
        physicianId = physicianIdorKey;
    }

    return {
        'physicianId': physicianId,
        'key': key,
        'from': from_str ? from_str.replace(/\//g, "-") : null,
        'to': to_str ? to_str.replace(/\//g, "-") : null
    };
};

el8.main.appScheduleReport.init = function(spec) {
    var that = this;

    spec['layout'] = {innerContainerSelector: '#schedule-report-container'};
    el8.app.setup(spec);

    el8.data.practiceUsers.load();

    el8React.configureStore(spec.data);
    el8React.renderFindChartHeaderButton('react-chartnav');
    el8React.renderSupportDialog('schedule-report-react-support-dialog-container')

    // setup infoFields and datePickers
    this.fromDateInfoField = el8.service.infoField.addInfoField({
        field: $('#schedule-report-date-from')
    });

    el8.uiwidget.addDatepicker(this.fromDateInfoField, {
        maxDate: el8.service.tz.today()
    });
    this.fromDateInfoField.setVal(el8.service.tz.todayPlusDays(-7).asString());

    this.toDateInfoField = el8.service.infoField.addInfoField({
        field: $('#schedule-report-date-to')
    });
    el8.uiwidget.addDatepicker(this.toDateInfoField, {
        maxDate: el8.service.tz.today()
    });
    this.toDateInfoField.setVal(el8.service.tz.today().asString());

    var from_param = el8.util.getUrlParam('from');
    var to_param = el8.util.getUrlParam('to');

    if (from_param) {
        var cleaner = from_param.replace(/-/g,'/');
        this.fromDateInfoField.setVal(el8.service.tz.newTzDate(cleaner).asString());
    }

    if (to_param) {
        var cleaner = to_param.replace(/-/g,'/');
        this.toDateInfoField.setVal(el8.service.tz.newTzDate(cleaner).asString());
    }

    // Is the date range > 15 days? If so, hide the print link and show a download CSV link
    if (el8.util.datecompare.daysBetween(el8.service.tz.newTzDate(from_param),
                                         el8.service.tz.newTzDate(to_param)) > 14) {
        $('.appointment-report-print-section').hide();
        $('.appointment-report-print-csv-section').show();
        // we're hiding the appt display when out of range so we don't see
        // the "no appt in this date range" message
        $('.appointment-report-content-section').hide();
        $('.appointment-report-out-of-range-message').show();
    } else {
        $('.appointment-report-print-csv-section').hide();
        $('.appointment-report-content-section').show();
        $('.appointment-report-out-of-range-message').hide();
    }

    //
    // triggers
    //
    $('#appointment-report-fetch-btn').click(function(e) {
        var params = that._getParams();
        window.location = el8.service.urls.get('scheduleReport',
                                               [params['physicianId'],
                                                params['key'],
                                                params['from'],
                                                params['to']]);

    });

    $('#schedule-report-physician-select').on('change', (function() {
        if ($('#appointment-report-fetch-btn').prop('disabled')) {
            $('#appointment-report-fetch-btn').removeAttr('disabled')
        }
    }))
    
    $(document).on('click', '.print-trigger',  function(e) {

        var printPath = window.location.pathname + 'printout/' + window.location.search;
        window.open(printPath);

    }).on('click', '.download-csv-trigger',  function() {
        var params = that._getParams();
        el8.appanalytics.dialog.scheduleReportCSV.show(params['physicianId'],
                                                       params['key'],
                                                       params['from'],
                                                       params['to']);
    });
};